<template>
  <div class="auto-extension-toggle">
    <v-switch
      :input-value="localValue"
      :loading="submitting"
      :disabled="submitting"
      label="自動延長"
      hide-details
      dense
      class="ma-0 pa-0"
      @change="onChange"
    />
  </div>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import { useTableUpdate } from '@/views/composable/useTableUpdate'

export default {
  props: {
    tableId: {
      type: [Number, String],
      required: true,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const localValue = ref(props.value)
    const { submitting, run } = useTableUpdate(() => props.tableId)

    // 親からの値が変わったら追従する
    watch(() => props.value, newValue => {
      localValue.value = newValue
    })

    // NOTE: 延長=課金の設定なので、API失敗時は元の状態へ復旧する（既存トグルと同方針）
    const onChange = async next => {
      const previous = localValue.value
      localValue.value = next

      const table = await run(
        { autoExtensionEnabled: next },
        { successMessage: '自動延長を更新しました', errorMessage: '自動延長の更新に失敗しました' },
      )

      if (table) emit('updated:table', table)
      else localValue.value = previous
    }

    return {
      localValue,
      submitting,
      onChange,
    }
  },
}
</script>
